export default "__VITE_PUBLIC_ASSET__fc547cf1__"